import * as React from 'react';
import { connect } from 'react-redux';
import State from '../../application/core/State';
import './MyAccount.css';
import UserDetails from '../UserDetails';
import User from '../../application/user/State';
import Customer from '../../domain/Customer';

interface StateProps {
    userInformation: User;
}

class MyAccount extends React.PureComponent<StateProps> {
    public render(): JSX.Element {
        return (
            <div className="my-account-card-container">
                <UserDetails title="MY ACCOUNT" customer={this.getUserDetailsData()} isAdmin={false} />
            </div>
        );
    }

    private getUserDetailsData = (): Customer => {
        return {
            customerId: this.props.userInformation.customerId,
            name: this.props.userInformation.name,
            email: this.props.userInformation.email,
            currency: '',
            discountRate: this.props.userInformation.discountRate,
            liabilityRate: this.props.userInformation.liabilityRate,
            billingAddress: this.props.userInformation.billingAddress,
            shippingAddress: this.props.userInformation.shippingAddress,
            shippingMethod: this.props.userInformation.shippingMethod
        };
    };
}

const mapStateToProps = (state: State): StateProps => ({
    userInformation: state.user
});

export default connect(mapStateToProps)(MyAccount);



// WEBPACK FOOTER //
// ./src/view/account/MyAccount.tsx